class NewsletterService {
    static subscribe = async (values) => {
        const body = new FormData();
        Object.keys(values).forEach((key) => {
            body.append(key, values[key]);
        });

        body.append('source', window.location.href);
        body.append('langcode', document.documentElement.lang);

        try {
            return await fetch(`/${document.documentElement.lang}/api/newsletter`, {
                credentials: 'include',
                method: 'post',
                body,
            });
        } catch (error) {
            return error;
        }
    };
}

export default NewsletterService;
